export default __webpack_public_path__ + "static/media/user.fdc17faa.svg";